
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/sliding-doors/aluron",
      function () {
        return require("private-next-pages/alu/sliding-doors/aluron/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/sliding-doors/aluron"])
      });
    }
  